import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import StickyPaperTableContainer from "component/sticky/StickyPaperTableContainer";
import t from "module/translations";
import { EntityIdentifier } from "module/entity/types";
import ButtonsContainer from "component/button/ButtonsContainer";
import ElementWithConfirmation from "component/elementWithConfirmation/ElementWithConfirmation";
import SignButton from "component/button/SignButton";
import { getEntityIdentifierKey } from "module/entity/helper/getEntityIdentifierKey";
import CertificationSessionTableHead from "module/certificationSession/enrichedComponent/tableHead/CertificationSessionTableHead";
import CertificationSessionContextProvider from "module/certificationSession/context/CertificationSessionContextProvider";
import CertificationSessionTableRowContainer from "module/certificationSession/enrichedComponent/tableRow/CertificationSessionTableRowContainer";

interface Props {
  sessionsIdentifiers: EntityIdentifier[];
  sign: () => Promise<void>;
}

const CertificationToBeSignedDetailsSessions: React.FC<Props> = ({
  sessionsIdentifiers,
  sign,
}) => {
  return (
    <>
      <StickyPaperTableContainer>
        <Table stickyHeader>
          <CertificationSessionTableHead />
          <TableBody>
            {sessionsIdentifiers.map((session) => (
              <CertificationSessionContextProvider
                {...{
                  entityIdentifier: session,
                  key: getEntityIdentifierKey(session),
                }}
              >
                <CertificationSessionTableRowContainer />
              </CertificationSessionContextProvider>
            ))}
          </TableBody>
        </Table>
      </StickyPaperTableContainer>
      <ButtonsContainer>
        <ElementWithConfirmation
          {...{
            confirmationDialogTitle:
              t.competencyManagement.signConfirmationText,
            asyncAction: sign,
          }}
        >
          {(props: { onClick: () => void }) => (
            <SignButton {...{ onClick: props.onClick }} />
          )}
        </ElementWithConfirmation>
      </ButtonsContainer>
    </>
  );
};

export default React.memo(CertificationToBeSignedDetailsSessions);
